module.exports = __webpack_public_path__ + "static/ss.5bf3f7b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/rc/ss.jpg
// module id = 1173
// module chunks = 277036769636407